module.exports = __webpack_public_path__ + "img/battery-quarter.ee3589c9.svg";